<payee-popup [onCancel]="cancel">
  <ng-template #payeePopupTitleTemplate>
    <h1>Esemény napló létrehozása</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate>
    <p>Manuálisan rögzíthet egy esemény naplót az ügyhöz anélkül, hogy lefuttatná az átmenetet.</p>
  </ng-template>

  @if (dialogData) {
    <form
      class="create-transition-log-form"
      [formGroup]="form"
    >
      <payee-form-field width="max">
        <span payee-label>Átmenet</span>
        <payee-autocomplete
          placeholder="Keresés csoport, név vagy osztály szerint"
          formControlName="transition"
          [options]="dialogData.transitions"
          [displayWith]="transitionDisplayWith"
          [filterPredicate]="transitionFilterPredicate"
        >
          <ng-template
            #optionTemplate
            let-transition
          >
            <div class="state-option">
              <div class="state-label">{{ transition.group }}: {{ transition.label }}</div>
              @if (isDuplicateLabel(transition.label)) {
                <div class="state-id">
                  {{ transition.id }}
                </div>
              }
            </div>
          </ng-template>
        </payee-autocomplete>
      </payee-form-field>

      <div class="flex vcenter">
        <payee-form-field width="short">
          <span payee-label>Esemény dátuma</span>
          <payee-datepicker formControlName="date"></payee-datepicker>
        </payee-form-field>

        <payee-form-field width="short">
          <span payee-label>Esemény ideje</span>
          <input
            payee-input
            type="time"
            formControlName="time"
          />
        </payee-form-field>
      </div>

      <div class="file-upload-section">
        <payee-form-field width="max">
          <span payee-label>Csatolt fájlok (opcionális)</span>
          <payee-dropzone
            title="Tölts fel fájlokat (Max. 10MB)"
            [multiple]="true"
            [isDisabled]="loading"
            (dropped)="filesDropped($event)"
          ></payee-dropzone>
        </payee-form-field>

        @if (files.length > 0) {
          <div class="selected-files">
            @for (file of files; track file.name; let i = $index) {
              <div class="selected-file">
                <payee-icon name="upload-paper"></payee-icon>
                <span class="file-name">{{ file.name }}</span>
                <button
                  payee-mini-icon-button
                  color="white"
                  type="button"
                  [disabled]="loading"
                  (click)="removeFile(i)"
                >
                  <payee-icon name="trash-red"></payee-icon>
                </button>
              </div>
            }
          </div>
        }
      </div>
    </form>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
</payee-popup>
